module.exports = "/static/img/phone-icon.03627ba899f063eb478f158d52a0eb2f.png";